import { attr, belongsTo } from '@ember-data/model';
import ShModel from 'sh-www/models/sh-model';

class OAuthProvider extends ShModel {
  @attr('string') provider;
  @attr('string') providerId;
  @attr('string') email;
  @attr('string') firstName;
  @attr('string') middleName;
  @attr('string') lastName;

  @attr('date') createdAt;
  @attr('date') updatedAt;

  @belongsTo('user', { async: false }) user;

  get fullName() {
    return [this.firstName, this.middleName, this.lastName].join(' ').replace(/\s+/g, ' ');
  }
}

export default OAuthProvider;
